import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import messages from './messagesDiscountsAndLoyalties';
import styles from './styles';

const DiscountsAndLoyalties = ({
    paxInfo,
    disabled,
    classes,
    intl: { formatMessage },
    onChange,
    errors,
}) => {
    const aggregatedDiscounts = paxInfo.getIn(['discountsLoyalties', 'aggregatedDiscounts']);
    const loyaltyItems = [];
    paxInfo.getIn(['discountsLoyalties', 'aggregatedLoyalties']).forEach((item) => {
        if (item.get('ShoppingLegFareDiscountType') === 'LOYALTY') {
            const alreadyAdded = loyaltyItems.find((loyaltyItem) => (
                loyaltyItem.value === item.get('ShoppingLegFareDiscountProgram')
            ));

            if (!alreadyAdded) {
                loyaltyItems.push({ value: item.get('ShoppingLegFareDiscountProgram'), name: item.get('ShoppingLegFareDiscountDescription') });
            }
        }
    });

    const loyaltyList = [{ value: '', name: formatMessage(messages.lblSelectProgram) }].concat(loyaltyItems);

    const handleChange = (name, value) => {
        const updates = { [name]: value };
        onChange(updates);
    };

    const handleChangeField = (event) => {
        handleChange(event.target.name, event.target.value);
    };

    const handleChangeLoyaltyProgram = ({ target: { value } }) => {
        handleChange('loyaltyProgram', value);
    };

    return (
        <div className="col-12">
            <h5>{formatMessage(messages.lblDiscountsLoyalties)}</h5>
            {aggregatedDiscounts.map((item) => {
                const isFRMilitaire = item.get('ShoppingLegFareDiscountProgram').includes('FR_MILITAIRE');
                if (item.get('ShoppingLegFareDiscountType') === 'DISCOUNT_CARD') {
                    return (
                        <div className="row" key={item.get('ShoppingLegFareDiscountProgram')}>
                            <div className="col-12">
                                {formatMessage(messages.lblDiscountCards)}
                            </div>
                            <div className={classNames('col-6', classes.rowBottomAlign, classes.cardText)}>
                                {item.get('ShoppingLegFareDiscountDescription')}
                            </div>
                            <div className={classNames('col-6', classes.rowBottomAlign)}>
                                <TextField
                                    id="srtDiscountIdentifier"
                                    name="discountIdentifier"
                                    label={formatMessage(messages.lblDiscountCardNumber)}
                                    fullWidth
                                    disabled={isFRMilitaire || disabled}
                                    value={paxInfo.getIn(['discountsLoyalties', isFRMilitaire ? 'corporateIdentifier' : 'discountIdentifier'])}
                                    onChange={handleChangeField}
                                    error={!!errors.discountIdentifier}
                                    helperText={errors.discountIdentifier}
                                />
                            </div>
                            {item.get('ShoppingLegFareDiscountIsAuthorizationRequired') && (
                                <div className={classNames('col-6', classes.rowBottomAlign)}>
                                    <TextField
                                        id="srtDiscountAuthorization"
                                        name="discountAuthorization"
                                        label={formatMessage(messages.lblDiscountAuthorization)}
                                        fullWidth
                                        disabled={disabled}
                                        value={paxInfo.getIn(['discountsLoyalties', 'discountAuthorization'])}
                                        onChange={handleChangeField}
                                        error={!!errors.discountAuthorization}
                                        helperText={errors.discountAuthorization}
                                    />
                                </div>
                            )}
                        </div>
                    );
                }
                if (item.get('ShoppingLegFareDiscountType') === 'CORPORATE' || item.get('ShoppingLegFareDiscountType') === 'PROMOTION') {
                    return (
                        <div className={classNames('row', classes.corporateRow)} key={item.get('ShoppingLegFareDiscountProgram')}>
                            <div className="col-12">
                                {formatMessage(messages.lblCorporateCard)}
                            </div>
                            <div className={classNames('col-6', classes.rowBottomAlign, classes.cardText)}>
                                {item.get('ShoppingLegFareDiscountDescription')}
                            </div>
                            {(item.get('ShoppingLegFareDiscountIsIdentifierRequired')
                                || !!paxInfo.getIn(['discountsLoyalties', 'corporateIdentifier'])) && (
                                <div className={classNames('col-6', classes.rowBottomAlign)}>
                                    <TextField
                                        id="srtCorporateIdentifier"
                                        name="corporateIdentifier"
                                        label={formatMessage(messages.lblDiscountCardNumber)}
                                        fullWidth
                                        disabled={disabled || !item.get('ShoppingLegFareDiscountIsIdentifierRequired')}
                                        value={paxInfo.getIn(['discountsLoyalties', 'corporateIdentifier'])}
                                        onChange={handleChangeField}
                                        error={!!errors.corporateIdentifier}
                                        helperText={errors.corporateIdentifier}
                                    />
                                </div>
                            )}
                            {item.get('ShoppingLegFareDiscountIsAuthorizationRequired') && (
                                <div className={classNames('col-6', classes.rowBottomAlign)}>
                                    <TextField
                                        id="srtCorporateAuthorization"
                                        name="corporateAuthorization"
                                        label={formatMessage(messages.lblDiscountAuthorization)}
                                        fullWidth
                                        disabled={disabled}
                                        value={paxInfo.getIn(['discountsLoyalties', 'corporateAuthorization'])}
                                        onChange={handleChangeField}
                                        error={!!errors.corporateAuthorization}
                                        helperText={errors.corporateAuthorization}
                                    />
                                </div>
                            )}
                        </div>
                    );
                }
                return null;
            }).toJS()}
            {!!loyaltyItems.length && (
                <div className="row">
                    <div className="col-12">
                        {formatMessage(messages.lblLoyaltyCard)}
                    </div>
                    <div className="col-6">
                        <TextField
                            id="srtLoyaltyProgram"
                            disabled={disabled}
                            value={paxInfo.getIn(['discountsLoyalties', 'loyaltyProgram']) || ''}
                            onChange={handleChangeLoyaltyProgram}
                            SelectProps={{
                                autoWidth: true,
                                displayEmpty: true,
                            }}
                            select
                        >
                            {loyaltyList.map((item) => (
                                <MenuItem
                                    key={item.value}
                                    value={item.value}
                                >
                                    {item.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    {paxInfo.getIn(['discountsLoyalties', 'loyaltyProgram']) && (
                        <div className="col-6">
                            <TextField
                                id="srtLoyaltyIdentifier"
                                name="loyaltyIdentifier"
                                placeholder={formatMessage(messages.lblLoyaltyCardNumber)}
                                fullWidth
                                disabled={disabled}
                                value={paxInfo.getIn(['discountsLoyalties', 'loyaltyIdentifier'])}
                                onChange={handleChangeField}
                                error={!!errors.loyaltyIdentifier}
                                helperText={errors.loyaltyIdentifier}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

DiscountsAndLoyalties.propTypes = {
    classes: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    paxInfo: PropTypes.object,
    intl: PropTypes.object,
};

// This alias will be used to access bare component for unit testing
export { DiscountsAndLoyalties as DiscountsAndLoyaltiesAlias };

export default injectIntl(withStyles(styles)(DiscountsAndLoyalties));
